var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0715 62.8989C99.8504 34.364 66.6755 16.1876 56.6013 11.4236C46.5271 6.65954 39.0885 8.88652 28.848 21.6654C18.6076 34.4442 20.0477 56.5179 19.8988 65.8221C19.7499 75.1263 37.3478 98.5676 72.0715 62.8989Z",
    fill: "#94DEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22656 32.7857L16.5832 17.0459H45.4154L57.772 32.7857L30.9993 66.3641L4.22656 32.7857Z",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 32.5459H54.956",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5469 32.8012L31.706 18.4541L40.8651 32.8012L31.0014 63.545L22.5469 32.8012Z",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamond-icon.84b68d52.svg";
export { ForwardRef as ReactComponent };